import {defineStore} from 'pinia'
import moment from 'moment'
import api from '@/services/api'

export const usePrintGiftsReportsStore = defineStore('printGiftsReports', {
    state: () => ({
        reports: [
            {name: 'relatedProducts', label: 'Related products'}
        ],
        formData: {
            reportName: '',
            primaryCategory: 0,
            startDate: '',
            endDate: ''
        },
        isLoading: false,
        rows: undefined
    }),
    
    getters: {
        startTimestamp(state) {
            return moment(state.formData.startDate, 'YYYY-MM-DD').unix()
        },
        endTimestamp(state) {
            // The date input type has no time, so equates to the time 00:00:00,
            // so add the number of seconds in a day minus 1 to get 23:59:59
            return moment(state.formData.endDate, 'YYYY-MM-DD').unix() + 86399
        },
        getDate: () => (timestamp) => {
            return timestamp ? moment(timestamp).format('DD/MM/YYYY') : ''
        }
    },
    
    actions: {
        init({query}) {
            // Support for copying and pasting URLs.
            // On load, if a query string has already been set then apply it to state.formData and load the rows
            if (
                query.reportName // Only apply the query to formData if the query string has been set with vars
                //&& JSON.stringify(query) !== JSON.stringify(this.formData)
            ) {
                Object.assign(this.formData, query)
                this.formData.reportName = query.reportName
                this.loadRows()
            }
        },
        
        loadRows() {
            this.rows = undefined
            this.isLoading = true
            
            switch (this.formData.reportName) {
                case 'relatedProducts':
                    this.relatedProducts()
                    break
            }
        },
        
        async relatedProducts() {
            let o
            
            const response = await api.get('api/categories/get-table-column-data/m_products_products/relatedProducts')
            const categoryData = response.data
            const productIds = [...new Set(categoryData.map(o => o.itemId))]
            const categoryIds = [...new Set(categoryData.map(o => o.catId))]
            
            const postData = {
                ids: productIds,
                fields: ['id', 'title'],
                status: 1,
                isArchived: 0,
                modifiedDate: {
                    ge: this.startTimestamp,
                    le: this.endTimestamp
                }
            }
            
            if (this.formData.primaryCategory) {
                postData.categoryId = this.formData.primaryCategory
            }
            
            o = await api.post('api/component/m_products_products', postData, {
                headers: {
                    'X-Http-Method-Override': 'GET'
                }
            })
            const productTitles = o.data.items
            
            o = await api.post('api/component/m_products_products', {
                ids: categoryIds,
                fields: ['id', 'status', 'isArchived']
            }, {
                headers: {
                    'X-Http-Method-Override': 'GET'
                }
            })
            const products = o.data.items
            
            const rows = []
            
            productTitles.forEach(product => {
                const href = '/#/m_products_products/' + product.id
                
                const categoryIds = categoryData.filter(o => o.itemId === product.id).map(o => o.catId)
                const items = products.filter(o => categoryIds.indexOf(o.id) > -1)
                const publishedProductIds = items.filter(o => o.status === 1 && o.isArchived === 0).map(o => o.id)
                const unpublishedProductIds = items.filter(o => o.status === 0 && o.isArchived === 0).map(o => o.id)
                const archivedProductIds = items.filter(o => o.isArchived === 1).map(o => o.id)
                const row = {
                    'Product': product.title,
                    'ID': '<a href="' + href + '">' + product.id + '</a>',
                    'No. of published products': publishedProductIds.length,
                    'Published products': publishedProductIds.join(', '),
                    'No. of unpublished products': unpublishedProductIds.length,
                    'Unpublished products': unpublishedProductIds.join(', '),
                    'No. of archived': archivedProductIds.length,
                    'Archived products': archivedProductIds.join(', ')
                }
                
                rows.push(row)
            })
            
            this.rows = rows
            this.isLoading = false
        }
    }
})